import { render, staticRenderFns } from "./ShopTheLookItem.vue?vue&type=template&id=010813f7"
import script from "./ShopTheLookItem.vue?vue&type=script&lang=js"
export * from "./ShopTheLookItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports